import { get } from "@common/services/request";

export function getUserActionById(Id, sessionId) {
  return get(`v1/sessions/${sessionId}/user_actions/${Id}/`);
}
